<div id="content-container"> 
    <div class="no-print">
      <h2 class="dashpanel-h4">Safe Harbor Admin</h2>
    </div>

    <div>
      <app-select [hidden]="dontShowStep1" 
                  (selectedSH)="childEventClicked($event)" 
                  (selectedReleaseDate)="releaseDateClicked($event)" 
                  (selectedEffectiveDate)="efectiveDateClicked($event)" >
      </app-select>
     </div>     

     <div>
      <app-complete [hidden]="dontShowStep2" 
                    [shSelected]=safeHarborPlans 
                    [shEffectiveDate]=safeHarborEffectiveDate
                    [shReleaseDate]=safeHarborReleaseDate 
                    (back)="backButtonClicked($event)"></app-complete> 
    </div>     
</div>